/*
 * Jira Ticket:
 * Created Date: Wed, 15th Apr 2020, 16:56:08 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';

export const createSubcontractMutation = gql`
  mutation createSubcontract(
    $organisationId: ID!
    $contractorId: ID!
    $subcontractorId: ID!
    $projectIds: [ID!]!
    $role: SubcontractorRole!
    $allowSubcontracting: Boolean
  ) {
    data: createSubcontract(
      organisationId: $organisationId
      contractorId: $contractorId
      subcontractorId: $subcontractorId
      projectIds: $projectIds
      role: $role
      allowSubcontracting: $allowSubcontracting
    ) {
      id
      role
      organisation {
        id
      }
      contractor {
        id
      }
      subcontractor {
        id
      }
      projects {
        id
      }
      allowSubcontracting
      status
      statistics {
        numberOfUsers
      }
    }
  }
`;
